import { AddToCartRequest, AddToCartRequestType, AddToCartPackageRequest } from "../mvcapi/models/buyticket/ticketselection";
import { SelectedTicketInfo, SelectedTicketsByEventDateId } from "./models";
import { AddToCartPackageItem, getPackageDateItemsByEventDateId } from "../stores/add-to-cart-stores/models/add-to-cart-items";
import { EventDateDisplayMode, EventDateInfo } from "../mvcapi/models/common";
import { InSaleStatus } from "../types/models";
import { uniq, uniqBy } from "lodash";
import { EMPTY_UUID } from "./util";

/**
 * Returns an compatible AddToCartRequest based on the selected tickets with their price
 * INFO: New sale
 */
export function createAddToCartRequest(eventDateId: number, selectedTicketsByEventDateId: SelectedTicketsByEventDateId): AddToCartRequest {
    const tickets = selectedTicketsByEventDateId[eventDateId]?.selectedTickets || [];
    return createAddToCartRequestFromDateTickets(tickets, AddToCartRequestType.EventDate);
}

export function createAddToCartPackageRequest(packageId: number, packageItems: AddToCartPackageItem[], selectedEventDateIds: number[]): AddToCartPackageRequest {
    const eventDateAddRequests = [];
    selectedEventDateIds.map((eventDateId) => {
        const dateTicketItems = getPackageDateItemsByEventDateId(packageItems, eventDateId);
        const tickets = dateTicketItems.map(d => d.ticket);

        const addToCartRequest = createAddToCartRequestFromDateTickets(tickets, AddToCartRequestType.Package);
        if(addToCartRequest != null) {
            eventDateAddRequests.push(addToCartRequest);
        }
    });



    if(eventDateAddRequests != null && eventDateAddRequests.length > 0) {
        return {
            type: AddToCartRequestType.Package,
            packageID: packageId,
            eventDates: eventDateAddRequests,
            supportsCCCondition: true, 
            supportsMembershipCondition: true, 
            deliveryMethodSet: false, 
            shipTicketsByMail: false, 
            shipTicketsByETicket: false,
        }as AddToCartPackageRequest;
    } else 
        return null; 
}

/**
 * Returns an compatible AddToCartRequest based on the selected tickets with their price
 * INFO: New sale
 */
export function createAddToCartRequestFromDateTickets(tickets: SelectedTicketInfo[], type: AddToCartRequestType): AddToCartRequest {
    if(tickets != null && tickets.length > 0) {
        return {
            eventDateID: tickets[0].ticket.EventDateID,
            type: type,
            ticketPrices: tickets.map(ticketInfo => ({
                ticketID: ticketInfo.ticketId,
                priceID: ticketInfo.priceId
            })),
            shipTicketsByMail: false,
            shipTicketsByETicket: false,
            deliveryMethodSet: false,
            supportsCCCondition: true,
            supportsMembershipCondition: true
        };
    } else
        return null;
}


export function getFilteredEventDateInfos(eventDateInfos: EventDateInfo[]): EventDateInfo[] {
    return eventDateInfos.filter(eventDateInfo => eventDateInfo.InSaleStatus != InSaleStatus.HIDEONINTERNET && eventDateInfo.InSaleStatus != InSaleStatus.PAST);
}

/**
 * Sert à savoir quand afficher les dates de l'événement en mode bouton ou combo
 * @param eventDateInfos 
 * @returns Display mode
 */
export function getEventDateDisplayMode(eventDateInfos: EventDateInfo[]): EventDateDisplayMode {
    const filteredEventDateInfos = getFilteredEventDateInfos(eventDateInfos);

    const countPromos = uniq(filteredEventDateInfos
        .filter(eventDateInfo => eventDateInfo.PromoInfo != null && eventDateInfo.PromoInfo.PromoID != EMPTY_UUID)
        .map(eventDateInfo => eventDateInfo.PromoInfo.PromoID)
    ).length;

    return countPromos <= 1 && (filteredEventDateInfos.length > 0 
    && filteredEventDateInfos.length <= 10) ? "button" : "combo";
}


export function checkHasSameVenueNames(eventDateInfos: EventDateInfo[]): boolean {
        const filteredEventDateInfos = getFilteredEventDateInfos(eventDateInfos);

        return uniqBy(filteredEventDateInfos, "VenueName").length <= 1;
    }
